var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('n-field-select',_vm._g(_vm._b({},'n-field-select',_vm.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }